// One muted pill per additional lead signal on a property ("Mortgage
// Foreclosure", "Probate", ...), instead of an opaque "+N" whose names were
// only in a tooltip. A card has little width, so past MAX_NAMED_SIGNALS the
// remainder collapses into a single "+N" with the names in its tooltip.

export const MAX_NAMED_SIGNALS = 3;

export interface OtherSignalPillsProps {
  labels: string[] | undefined;
}

export default function OtherSignalPills({ labels }: OtherSignalPillsProps) {
  if (!labels || labels.length === 0) return null;
  const named = labels.slice(0, MAX_NAMED_SIGNALS);
  const rest = labels.slice(MAX_NAMED_SIGNALS);
  return (
    <>
      {named.map((label) => (
        <span
          key={label}
          className="lrow-pill lrow-pill--muted"
          title={`Also a lead signal on this property: ${label}`}
        >
          {label}
        </span>
      ))}
      {rest.length > 0 && (
        <span className="lrow-pill lrow-pill--muted" title={`Also: ${rest.join(", ")}`}>
          +{rest.length}
        </span>
      )}
    </>
  );
}
